import React, { useEffect } from 'react';
import { Container, SubContainer } from '../../components/Container';
import { Button } from '../../components/Button';
import Title from '../../components/Title';
import { CallbackWrapper } from './styles';
import { redirect } from '../../common/redirect';
import { useLocation } from 'react-router-dom';
import { removeUnsafeCharsFromString } from '../../common/Helpers';

const Callback = (): JSX.Element => {

  const location = useLocation()

  useEffect(() => {
    const timeout = setTimeout(() => {
      redirectMobile();
    }, 5000);

    return () => {
      clearTimeout(timeout);
    };
  }, []);

  const redirectMobile =  () => {
    const cleanPath = location.pathname.replace(/[^a-zA-Z0-9\-_\/]/g, '');

    const cleanHash = removeUnsafeCharsFromString(location.hash)

    if (/Android/i.test(navigator.userAgent)) {
      window.location.href = `unicredMobile://openfinance${cleanPath}${cleanHash}`;
    }

    setTimeout(function() {
      redirect();
    }, 100);
  }

  return (
    <Container>
      <SubContainer>
        <CallbackWrapper>
          <Title title="Redirecionamento">
            <p>Sua solicitação está sendo processada, continue pelo aplicativo Unicred Mobile pelo botão a seguir.</p>
          </Title>
          <Button
            className="full"
            value="Continuar no app Unicred Mobile"
            onClick={redirectMobile}
          />
        </CallbackWrapper>
      </SubContainer>
    </Container>
  );
};

export default Callback;